import type { LoaderProps } from '@/components/landing-page/components/loader';

export const defaults: Required<LoaderProps> = {
  text: '<strong>Vielen Dank.</strong> Bitte haben Sie einen Augenblick Geduld, wir analysieren gerade Ihre Angaben...',
  className: '',
};
